<!--
  使用用户名密码登录 https://www.everiaction.com/#/avoidLogin?username=13622114075&password=13622114075!123
  使用加密后的token登陆 https://www.everiaction.com/#/avoidLogin?token=xxx&kt=xxx
  免登录后，嵌套单独的页面 上面两个链接添加  https://www.everiaction.com/multiplePage.html#/avoidLogin?username=liuxingxing&password=liuxingxing&projectId=982&path=/platform/spotMonitor2
  http://localhost:182/multiplePage.html#/avoidLogin?username=liuxingxing&password=liuxingxing&projectId=1229&path=/platform/spotMonitor2
  此处需要注意：如果项目id不对
-->
<template></template>
<script>
/* eslint-disable */
import { setToken, setSystemRole } from "@/utils/auth";
import { getParams, getDomainPrefix } from "@/utils/common";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "avoidLogin",
  data() {
    return {};
  },
  created(params) {
    this.handleLogin();
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    handleLogin() {
      let {
        username,
        password,
        token,
        kt,
        encryPassword,
        salt,
        sso,
        bridgeCode,
      } = getParams();
      username = decodeURIComponent(username);
      password = decodeURIComponent(password);
      let loginForm = {
          username: username,
          password: password,
          salt: salt || "", // 加密标识
        },
        url = "auth/user/pass/login",
        interfaceType = this.$httpSys;

      let domainPrefix = getDomainPrefix(window.location.pathname);
      this.setCurrentDomain(domainPrefix);

      if (encryPassword) {
        //base64加密的password
        loginForm.password = decodeURIComponent(encryPassword);
        loginForm.salt = "base64";
      }
      if (token) {
        //查询用户信息
        setToken(token);
        this.$nextTick(() => {
          this.$httpSys.get("/auth/user").then((res) => {
            let obj = res.data;
            this.$store.commit("SET_USERINFO", obj.user);
            this.$store.commit("SET_SYSTEMROLE", obj.systemRole);
            setSystemRole(obj.systemRole);
            this.goNext();
          });
        });
      } else {
        if (bridgeCode) {
          url = `auth/user/pass/gzqtLogin?bridgeCode=${bridgeCode}&sso=${sso}`;
          loginForm = {};
        }
        interfaceType.post(url, loginForm).then((data) => {
          let obj = data.data;
          //设置用户信息
          obj.user.projectCurrent = obj.projectCurrent;
          this.$store.commit("SET_USERINFO", obj.user);
          setToken(obj.token);
          this.$store.commit("SET_SYSTEMROLE", obj.systemRole);
          setSystemRole(obj.systemRole);
          this.goNext();
        });
      }
    },
    goNext() {
      let { projectId, path } = getParams();
      path = path || "";
      path = decodeURIComponent(path);
      if (projectId) {
        this.queryInfoByProjectId();
      } else {
        this.$router.push({ path: path || "/platform/projectOverview" });
      }
    },
    /**
     * 通过项目id查询项目信息
     */
    queryInfoByProjectId() {
      let { projectId, path } = getParams();
      path = path || "";
      path = decodeURIComponent(path);
      this.$httpProj
        .get("proj/project/getByIdDetail?projectId=" + projectId)
        .then((data) => {
          this.$store.dispatch("setProjectId", data.data); //设置项目信息
          this.$router.push({ path: path || "/platform/location" });
        });
    },
    ...mapMutations({
      setCurrentDomain: "SET_CURRENTDOMAIN",
    }),
  },
};
</script>
